<template>
<div :style="{display: search.display}" class="modal-dialog modal-md dialog-search">
    <div :style="{padding: '0px', margin: '0px'}" tabindex="-1" class="modal-content">
      <header class="modal-header">
        <h5 class="modal-title">{{$t('searcher')}}</h5>
        <button @click="searchModalClose" type="button" aria-label="Close" class="close">×</button>
      </header>
      <div class="modal-body-forum-search">
        <b-row class="search-row">
          <b-col cols="12" sm="3">
            <b>{{$t('categories')}}</b>
            <div class="content">
            <div class="btn search-options" @click="searchSelected(item.id, 1)" v-for="item in search.categories" :key="item.id">
              {{item[normalizeForumProp('name')]}}
            </div>
            </div>
            <div class="no-search-results" v-if="!search.categories || search.categories.length === 0">{{$t('noResults')}}</div>
          </b-col>
          <b-col cols="12" sm="3">
            <b>{{$t('tags')}}</b>
            <div class="content">
            <div class="btn search-options" @click="searchSelected(item.id, 2)" v-for="item in search.tags" :key="item.id">
              {{item[normalizeForumProp('name')]}}
            </div>
            </div>
            <div class="no-search-results" v-if="!search.tags || search.tags.length === 0">{{$t('noResults')}}</div>
          </b-col>
          <b-col cols="12" sm="3">
            <b>{{$t('diseasesForum')}}</b>
            <div class="content">
            <div class="btn search-options" @click="searchSelected(item.id, 4)" v-for="item in search.diseases" :key="item.id">
              {{item[normalizeForumProp('name')]}}
            </div>
            </div>
            <div class="no-search-results" v-if="!search.diseases || search.diseases.length === 0">{{$t('noResults')}}</div>
          </b-col>
          <b-col cols="12" sm="3">
            <b>{{$t('description')}}</b>
            <div class="content">
            <div class="btn search-options" @click="searchSelected(item.id, 3)" v-for="item in search.entries" :key="item.id">
              {{item.name}}
            </div>
            </div>
            <div class="no-search-results" v-if="$store.state.forum.entrySearchValue && (!search.entries || search.entries.length === 0)">{{$t('noResults')}}</div>
          </b-col>
        </b-row>
      </div>
    </div>
  </div>
</template>

<script>
import forumMixin from '@/mixins/forum.mixin'

export default {
    name: 'forumSearcher',
    components: {
      forumMixin
    },
    props: {
        search: Object
    },
    data () {
        return {
        }
    },
    mixins: [forumMixin],
    methods: {
      searchSelected (id, type) {
        this.$store.state.forum.entriesPageNumber = 0
        this.$store.state.forum.searchId = id
        this.$store.state.forum.searchType = type
        this.$store.state.forum.showingSearch = true
        this.searchModalClose()
        this.loadForumEntries()
        this.$router.push(this.getPathUrl()).catch(() => {
        })
      },
      searchModalClose () {
        this.$store.state.forum.entrySearchValue = null
        this.search.entries = []
        this.search.categories = []
        this.search.tags = []
        this.search.display = 'none'
        if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
          document.getElementsByClassName('banner-title')[0].style.display = 'block'
          // this.$root.$emit('bv::toggle::collapse', 'nav-collapse')
        }
      }
    }
}
</script>

<style lang="scss">
.search-options {
  cursor: pointer;
  display: block !important;
  padding-top: 0.3rem !important;
  padding-bottom: 0.3rem !important;
  &:hover{
    background-color: #3238C4;
    border-color: #3238C4;
    color: #eee !important;
  }
}
.modal-body-forum-search{
  max-height: 80vh !important;
  @include media(mobile, tablets) {
    max-height: 70vh !important;
  }
}
.search-row{
 > div > div.content{
  overflow-y: auto !important;
  max-height: 14vh !important;
 @media (min-width: 576px) {
    max-height: 75vh !important;
  }
 }
}
.no-search-results{
  padding: 0.3rem 2.2rem;
}
</style>



// WEBPACK FOOTER //
// src/components/views/healthy-community/forum/ForumSearcher.vue